/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReportVersionMetadataDTO } from './ReportVersionMetadataDTO';
import {
    ReportVersionMetadataDTOFromJSON,
    ReportVersionMetadataDTOFromJSONTyped,
    ReportVersionMetadataDTOToJSON,
} from './ReportVersionMetadataDTO';

/**
 * 
 * @export
 * @interface ReportVersionListDTO
 */
export interface ReportVersionListDTO {
    /**
     * 
     * @type {Array<ReportVersionMetadataDTO>}
     * @memberof ReportVersionListDTO
     */
    reportVersionsMetadata: Array<ReportVersionMetadataDTO>;
    /**
     * 
     * @type {number}
     * @memberof ReportVersionListDTO
     */
    total: number;
}

/**
 * Check if a given object implements the ReportVersionListDTO interface.
 */
export function instanceOfReportVersionListDTO(value: object): value is ReportVersionListDTO {
    if (!('reportVersionsMetadata' in value) || value['reportVersionsMetadata'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function ReportVersionListDTOFromJSON(json: any): ReportVersionListDTO {
    return ReportVersionListDTOFromJSONTyped(json, false);
}

export function ReportVersionListDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportVersionListDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'reportVersionsMetadata': ((json['reportVersionsMetadata'] as Array<any>).map(ReportVersionMetadataDTOFromJSON)),
        'total': json['total'],
    };
}

export function ReportVersionListDTOToJSON(value?: ReportVersionListDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'reportVersionsMetadata': ((value['reportVersionsMetadata'] as Array<any>).map(ReportVersionMetadataDTOToJSON)),
        'total': value['total'],
    };
}

